import { CreateAdministrator } from '~/domain/usecases/administrator/redux';
import {
  iActionCreate,
  iActionCreateFailed,
  AdministratorTypes,
  iActionCreateSuccess,
} from '~/domain/interfaces/redux/administrator/create';

export const createRequest = (
  payload: CreateAdministrator.Params,
): iActionCreate => ({
  type: AdministratorTypes.CREATE,
  payload,
});

export const createSuccess = (
  params: CreateAdministrator.Model,
): iActionCreateSuccess => ({
  type: AdministratorTypes.CREATE_SUCCESS,
});

export const createFailed = (): iActionCreateFailed => ({
  type: AdministratorTypes.CREATE_FAILED,
});
